var _line, _g, _line2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHeadingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 24,
    viewBox: "0 0 444 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.0419922,
    y1: 11.5,
    x2: 200.042,
    y2: 11.5,
    stroke: "url(#paint0_linear_858_5393)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_858_5393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.289 0H217.534C218.514 0.00222829 219.453 0.392182 220.146 1.08464C220.839 1.7771 221.23 2.71576 221.233 3.69549V11.1904H213.593V3.69549C213.596 2.71613 213.986 1.77773 214.679 1.08529C215.371 0.392853 216.31 0.00267523 217.289 0Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.042 7.66463V7.43139C210.044 6.49739 210.416 5.60218 211.076 4.94151C211.736 4.28083 212.631 3.90844 213.565 3.90576L221.233 11.1903H213.565C212.631 11.1876 211.736 10.8152 211.076 10.1545C210.416 9.49384 210.044 8.59863 210.042 7.66463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.71 0H226.464C225.485 0.00245125 224.546 0.392504 223.853 1.08494C223.16 1.77738 222.769 2.71591 222.766 3.69549V11.1904H230.406V3.69549C230.403 2.71613 230.013 1.77773 229.321 1.08529C228.628 0.392853 227.689 0.00267523 226.71 0Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.957 7.66463V7.43139C233.955 6.49725 233.584 5.60191 232.923 4.94121C232.263 4.28051 231.368 3.90822 230.433 3.90576L222.766 11.1903H230.433C231.368 11.1878 232.263 10.8155 232.923 10.1548C233.584 9.49412 233.955 8.59878 233.957 7.66463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.289 23.9173H217.534C218.514 23.9147 219.453 23.5245 220.146 22.8319C220.839 22.1394 221.23 21.2007 221.233 20.221V12.7261H213.593V20.221C213.596 21.2004 213.986 22.1387 214.679 22.8313C215.371 23.5238 216.31 23.9142 217.289 23.9173Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.042 16.25V16.4849C210.044 17.4187 210.416 18.3134 211.077 18.9737C211.737 19.6341 212.631 20.0062 213.565 20.0089L221.233 12.7261H213.565C212.631 12.7288 211.737 13.1009 211.077 13.7612C210.416 14.4215 210.044 15.3163 210.042 16.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.71 23.9173H226.464C225.485 23.9144 224.546 23.5241 223.853 22.8316C223.16 22.1391 222.769 21.2006 222.766 20.221V12.7261H230.406V20.221C230.403 21.2004 230.013 22.1387 229.32 22.8313C228.628 23.5238 227.689 23.9142 226.71 23.9173Z",
    fill: "#399918"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.957 16.25V16.4849C233.955 17.4188 233.583 18.3137 232.923 18.974C232.262 19.6344 231.367 20.0064 230.433 20.0089L222.766 12.7261H230.433C231.367 12.7285 232.262 13.1006 232.923 13.7609C233.583 14.4213 233.955 15.3162 233.957 16.25Z",
    fill: "white"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 243.958,
    y1: 11.5,
    x2: 443.958,
    y2: 11.5,
    stroke: "url(#paint1_linear_858_5393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_858_5393",
    x1: 0.0419922,
    y1: 12.5,
    x2: 200.042,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_858_5393",
    x1: 243.958,
    y1: 12.5,
    x2: 443.958,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_858_5393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9155,
    height: 24,
    fill: "white",
    transform: "translate(210.042)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeadingLines);
export default __webpack_public_path__ + "static/media/white-heading-lines.86b252580afe7b1072f523711e5dd052.svg";
export { ForwardRef as ReactComponent };